/**
 * LeaderboardTabs Component
 * Tab navigation for different leaderboard types
 */

import React from 'react';
import {LeaderboardTabsList, LeaderboardType} from '../../types/leaderboard';
import './LeaderboardTabs.css';

interface LeaderboardTabsProps {
  activeTab: LeaderboardType | null;
  onTabChange: (tab: LeaderboardType) => void;
  tabs?: LeaderboardTabsList[];
}

const LeaderboardTabs: React.FC<LeaderboardTabsProps> = ({
  activeTab,
  onTabChange,
  tabs =[]
}) => {

  return (
    <div className="leaderboard-tabs">
      {tabs.map((tab : any) => (
        <button
          key={tab.type}
          className={`tab-button ${activeTab === tab.type ? 'active' : ''}`}
          onClick={() => onTabChange(tab.type)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};

export default LeaderboardTabs;
